import React, { ReactNode } from "react";
import {
  HeaderNav,
  StyledFooter,
  LocaleSensitiveContactlessBanner,
} from "tr-web";
import { HeaderNavProps } from "../../tr-web/HeaderNav.stories";
import { useIsClient } from "../utilities/use-is-client";

export interface LayoutProps {
  children: ReactNode;
  headerNavProps?: HeaderNavProps;
}

export function Layout({ children, headerNavProps }: LayoutProps) {
  const { isClientKey } = useIsClient();

  return (
    <>
      <HeaderNav
        key={isClientKey + "HeaderNav"}
        servicesLinks={headerNavProps?.servicesLinks}
        serviceIndexPath={headerNavProps?.serviceIndexPath}
      />
      <LocaleSensitiveContactlessBanner />
      <main>{children}</main>
      <StyledFooter key={isClientKey + "StyledFooter"} />
    </>
  );
}
